import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TAttachmentDB } from '../../types/db';
import { actions as appActions } from '../../store/ducks/app';
import { TAttachmentCellSC } from './attachments-gallery.styled';

type TProps = {
  attachment: TAttachmentDB;
};

const AttachmentCell: React.FC<TProps> = ({ attachment }) => {
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [objectUrl, setObjectUrl] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (attachment.url) {
      setAttachmentUrl(attachment.url);
    } else if (attachment.blob) {
      const url = URL.createObjectURL(attachment.blob);
      setObjectUrl(url);
      setAttachmentUrl(url);
    }
  }, [attachment, setObjectUrl, setAttachmentUrl]);

  useEffect(() => {
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [objectUrl]);

  const openAttachment = () => {
    if (attachmentUrl && attachment.type?.includes('image')) {
      dispatch(
        appActions.openModal({
          id: 'IMAGE',
          data: {
            imgUrl: attachmentUrl,
            caption: '',
          },
        }),
      );
    } else if (attachmentUrl) {
      window.open(attachmentUrl);
    }
  };

  const renderContent = () => {
    if (attachment.type?.includes('image')) {
      return <div className="ac-image" style={{ backgroundImage: `url(${attachmentUrl})` }}></div>;
    } else {
      return (
        <a href={attachment.url} style={{ display: 'block' }} download={`${attachment.name}`}>
          <span className="ac-doc">{attachment.name}</span>
        </a>
      );
    }
  };

  return <TAttachmentCellSC onClick={openAttachment}>{renderContent()}</TAttachmentCellSC>;
};

export default AttachmentCell;
